// data
import { mobileMenuGenreLinks } from '@/components/Navigation/nav-data';

// components
import NavLink  from '@/components/Navigation/NavLink';

// styles
import styles from './MobileMenu.module.scss';

// svgs
import BackIcon from '@/public/svg/caret-prev.svg';
import GenresIcon from '@/public/svg/genres.svg';
import NextIcon from '@/public/svg/caret-next.svg';
import PassportCompass from '@/public/svg/compass-rose.svg';

interface MobileMenuGenresProps {
  genresOpen: boolean;
  isAccessibilityExploreHubEnabled: boolean;
  isLocalized: boolean;
  isPassportEnabled: boolean;
  onClick: () => void;
  setGenresOpen: (open: boolean) => void;
}

const MobileMenuGenres = (props: MobileMenuGenresProps) => {
  const {
    genresOpen,
    isAccessibilityExploreHubEnabled,
    isLocalized,
    isPassportEnabled,
    onClick,
    setGenresOpen,
  } = props;

  const genreLinks = mobileMenuGenreLinks({ isLocalized, isPassportEnabled, isAccessibilityExploreHubEnabled });

  return (
    <>
      <div className={styles.genres_toggle}>
        { genresOpen ? (
          <button
            onClick={() => setGenresOpen(!genresOpen)}
            aria-label="Close Genres Menu"
            className={styles.back_button}
          >
            <BackIcon />
          </button>
        ) : (
        <GenresIcon className={styles.genres_icon} />
        )}

        <button
          onClick={() => setGenresOpen(!genresOpen)}
          className={styles.genres_button}
          aria-expanded={genresOpen}
        >
          Genres
          { !genresOpen && (
            <NextIcon />
          )}
        </button>
      </div>

      <ul className={styles.genre_submenu}>
        {genreLinks.map((genre, index) => {
          return (
            <li key={index}>
              <NavLink
                href={genre.href}
                className={styles.mobile_menu_genre_nav_link}
                onClick={onClick}
              >
                { genre.include_passport_icon && <PassportCompass className={styles.passport_compass} /> }
                {genre.label}
              </NavLink>
            </li>
          )}
        )}
      </ul>
    </>
  );
}

export default MobileMenuGenres;
